import {Button, Menu, MenuItem} from '@material-ui/core';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import * as AgentNewsAdministrationRouteConstants from 'AgentNewsAdministration/AgentNewsAdministrationRouteConstants';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';
import RequireScope from 'Shared/components/RequireScope';
import {Scope} from 'Shared/constants/Scope';
import {UserRouteConstants} from 'Users/Routes';
import {CustomerSupportRouteConstants} from 'CustomerSupport/Routes';

export type AdministrationMenuProps = {
  scopes: Scope[];
} & RouteComponentProps;

export const AdministrationMenu = (props: AdministrationMenuProps) => (
  <RequireAtLeastOneScope
    scopes={[Scope.SearchExclusiveAgents, Scope.SearchAgentUsers, Scope.SearchPortalUsers, Scope.AlertsSearch]}
  >
    <MenuStateProvider>
      {({open, close, anchor}) => (
        <>
          <Button
            id="administration-menu-button"
            className="my-access-menu"
            variant="text"
            onClick={event => open(event.currentTarget)}
          >
            Administration
            <ArrowDown />
          </Button>
          <Menu
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            getContentAnchorEl={null}
            onClose={close}
            open={Boolean(anchor)}
            anchorEl={anchor}
          >
            <RequireScope scopes={props.scopes} scope={Scope.SearchAgentUsers}>
              <MenuItem
                className="my-access-menu__item"
                id="administration-menu-customer-support-item"
                onClick={() => {
                  props.history.push(CustomerSupportRouteConstants.CUSTOMER_SUPPORT);
                  close();
                }}
              >
                Customer Support
              </MenuItem>
            </RequireScope>
            <RequireScope scopes={props.scopes} scope={Scope.AlertsSearch}>
              <MenuItem
                className="my-access-menu__item"
                id="administration-menu-alerts-item"
                onClick={() => {
                  props.history.push(CoreRouteConstants.ALERTS);
                  close();
                }}
              >
                Alerts
              </MenuItem>
            </RequireScope>
            <RequireScope scopes={props.scopes} scope={Scope.AgentNewsAdministration}>
              <MenuItem
                className="my-access-menu__item"
                id="administration-menu-news-item"
                onClick={() => {
                  props.history.push(AgentNewsAdministrationRouteConstants.NewsAdministration);
                  close();
                }}
              >
                News
              </MenuItem>
            </RequireScope>
            <RequireAtLeastOneScope scopes={[Scope.SearchPortalUsers]}>
              <MenuItem
                className="my-access-menu__item"
                id="administration-menu-users-item"
                onClick={() => {
                  props.history.push(UserRouteConstants.USERS);
                  close();
                }}
              >
                Users
              </MenuItem>
            </RequireAtLeastOneScope>
          </Menu>
        </>
      )}
    </MenuStateProvider>
  </RequireAtLeastOneScope>
);

export default withRouter(AdministrationMenu);
